import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { canAccessAdminView } from "./adminAccess";
import AuthLoadingScreen from "./AuthLoadingScreen";
import { useAuth } from "./useAuth";

const ProtectedAdminGate = ({ adminView, children }) => {
  const navigate = useNavigate();
  const { isLoading, isAuthenticated, user } = useAuth();

  useEffect(() => {
    if (isLoading || !adminView) {
      return;
    }

    if (!isAuthenticated) {
      navigate("/login", {
        replace: true,
        state: { fromHash: window.location.hash || "" },
      });
      return;
    }

    if (!canAccessAdminView(user, adminView)) {
      navigate("/unauthorized", { replace: true });
    }
  }, [adminView, isAuthenticated, isLoading, navigate, user]);

  if (!adminView) {
    return children;
  }

  if (isLoading) {
    return <AuthLoadingScreen />;
  }

  if (!isAuthenticated || !canAccessAdminView(user, adminView)) {
    return <AuthLoadingScreen message="Redirecting…" />;
  }

  return children;
};

export default ProtectedAdminGate;
